module.exports = __webpack_public_path__ + "img/bomb.916d303b.png";